export default __webpack_public_path__ + "static/media/glassWater.b62d48b8.svg";